"use strict";

module.exports = function ceil(value) {
  //  discuss at: http://locutus.io/php/ceil/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: ceil(8723321.4)
  //   returns 1: 8723322

  return Math.ceil(value);
};
//# sourceMappingURL=ceil.js.map